import { render } from "./footer-banner.vue?vue&type=template&id=7a17d9fa&ts=true"
import script from "./footer-banner.vue?vue&type=script&lang=ts"
export * from "./footer-banner.vue?vue&type=script&lang=ts"

import "./footer-banner.vue?vue&type=style&index=0&id=7a17d9fa&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__